<template>
  <SelectContianer
    v-on:closeSelectContainer="close"
    :showChildSelect="showChildSelect"
  >
    <template slot="select-header">
      {{ letter.selectPayment }}
    </template>
    <template slot="select-content">
      <ul class="payment-select-container j-payment-select-container">
        <li
          class="areas-lst select-items-popup"
          :class="{ active: price.TRANS_AMOUNT == curPrice.TRANS_AMOUNT }"
          @click="selectPrice(price)"
          v-for="(price, index) in pricesList"
          :key="index"
        >
          {{ price.TRANS_AMOUNT }} {{ curPayType.show_currency }}
          <span class="get-text" style="margin: 0 5px">=</span>
          <template v-if="price.COIN">
            {{ parseInt(price.COIN || 0)
            }}<pay-ico :ico="directPayCoinIco"></pay-ico>
          </template>
          <template v-if="price.EXTRA_COIN">
            + {{ parseInt(price.EXTRA_COIN || 0)
            }}<pay-ico :ico="directPayExtraCoinIco"></pay-ico>
          </template>
          <span class="type-discount" v-if="price.EXTRA_RATIO && price.EXTRA_RATIO !== '0.00'">
            {{ letter.gainPlus }}
            {{ ~~(price.EXTRA_RATIO * 100) }}%
          </span>
        </li>
      </ul>
    </template>
  </SelectContianer>
</template>
<script>
import selectContainer from '@mixins/officialWebStore/selectContainer';
import { mapGetters } from 'vuex';
import PayIco from '@components/officialWebStore/paytype/PayIco.vue';
export default {
  name: 'bankPayment',
  props: ['pricesList', 'curPrice', 'curPayType'],
  mixins: [selectContainer],
  computed: {
    letter() {
      return this.$store.state.letter;
    },
    coinName() {
      return this.$store.state.coinName;
    },
    ...mapGetters(['directPayCoinIco', 'directPayExtraCoinIco'])
  },
  methods: {
    selectPrice(price) {
      this.$emit('selectPrice', price);
    }
  },
  components: {
    PayIco
  }
};
</script>
<style lang="scss" scoped>
.payment-select-container {
  padding-bottom: 80px;
}
.type-discount {
  margin: auto 12px;
}
</style>
